// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfferRulesAccept_wrapper__p1nOs {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  color: #E0E0E0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: #1B1E23;
  border-radius: 8px;
  line-height: 130%;
  max-height: 90%;
  max-width: 700px;
  overflow: hidden;
  padding: 20px 20px;
  padding-top: 60px;
  position: relative;
  width: 100%;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_title__fHZOu {
  border-bottom: 1px solid rgba(220, 220, 220, 0.1);
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 10px;
  padding-bottom: 20px;
  text-align: center;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_offer__7NJiI {
  max-height: 300px;
  overflow: hidden auto;
  padding-right: 10px;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_offer__7NJiI .OfferRulesAccept_center__BEHCY {
  text-align: center;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_offer__7NJiI::-webkit-scrollbar {
  width: 8px;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_offer__7NJiI::-webkit-scrollbar-track {
  background: #242424;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_offer__7NJiI::-webkit-scrollbar-thumb {
  background: #E0E0E0;
  border-radius: 4px;
  height: 54px;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_offer__7NJiI::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_closeBtn__khDZL {
  cursor: pointer;
  position: absolute;
  right: 24px;
  top: 20px;
}
.OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_btn__QBCsO {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

@media (max-width: 850px) {
  .OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_title__fHZOu {
    font-size: 20px;
    padding-top: 20px;
  }
  .OfferRulesAccept_wrapper__p1nOs .OfferRulesAccept_container__7Cfkv .OfferRulesAccept_offer__7NJiI {
    max-height: 400px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/OfferRulesAccept/OfferRulesAccept.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,oCAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AADF;AAGE;EC8CA,eAAA;EACA,gBAAA;EACA,kBAAA;ED7CE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAAJ;AAEI;EACE,iDAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAAN;AAGI;EACE,iBAAA;EACA,qBAAA;EACA,mBAAA;AADN;AAGM;EACE,kBAAA;AADR;AAKI;EACE,UAAA;AAHN;AAMI;EACE,mBAAA;AAJN;AAOI;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;AALN;AAQI;EACE,gBAAA;AANN;AASI;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAPN;AAUI;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;AARN;;AAaA;EAKM;IACE,eAAA;IACA,iBAAA;EAdN;EAiBI;IACE,iBAAA;EAfN;AACF","sourcesContent":["@import '../../../assets/styles/global.scss';\n\n.wrapper {\n  align-items: center;\n  background-color: rgba(0, 0, 0, .5);\n  bottom: 0;\n  color: #E0E0E0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 2;\n\n  .container {\n    @include body1;\n\n    background-color: #1B1E23;\n    border-radius: 8px;\n    line-height: 130%;\n    max-height: 90%;\n    max-width: 700px;\n    overflow: hidden;\n    padding: 20px 20px;\n    padding-top: 60px;\n    position: relative;\n    width: 100%;\n\n    .title {\n      border-bottom: 1px solid rgba(220, 220, 220, .1);\n      font-size: 32px;\n      font-weight: 700;\n      margin-bottom: 10px;\n      padding-bottom: 20px;\n      text-align: center;\n    }\n\n    .offer {\n      max-height: 300px;\n      overflow: hidden auto;\n      padding-right: 10px;\n\n      .center {\n        text-align: center;\n      }\n    }\n\n    .offer::-webkit-scrollbar {\n      width: 8px;\n    }\n  \n    .offer::-webkit-scrollbar-track {\n      background: #242424;\n    }\n  \n    .offer::-webkit-scrollbar-thumb {\n      background: #E0E0E0;\n      border-radius: 4px;\n      height: 54px;\n    }\n  \n    .offer::-webkit-scrollbar-thumb:hover {\n      background: #555;\n    }\n\n    .closeBtn {\n      cursor: pointer;\n      position: absolute;\n      right: 24px;\n      top: 20px;\n    }\n\n    .btn {\n      display: flex;\n      justify-content: end;\n      margin-top: 20px;\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n\n    .container {\n     \n      .title {\n        font-size: 20px;\n        padding-top: 20px;\n      }\n\n      .offer {\n        max-height: 400px;\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `OfferRulesAccept_wrapper__p1nOs`,
	"container": `OfferRulesAccept_container__7Cfkv`,
	"title": `OfferRulesAccept_title__fHZOu`,
	"offer": `OfferRulesAccept_offer__7NJiI`,
	"center": `OfferRulesAccept_center__BEHCY`,
	"closeBtn": `OfferRulesAccept_closeBtn__khDZL`,
	"btn": `OfferRulesAccept_btn__QBCsO`
};
export default ___CSS_LOADER_EXPORT___;
